import api from "../../api/api";
import { V2_BASE_URL } from "../../api/bases";
import { getPracticeId } from "../../config/practice";

/* Attendance clock-out corrections (v2 api/timesheets/corrections.py). Pinned to v2 (`_gw:
   "v2-pinned"`, as patientFiles.js and the fax code do): the routes exist on v2 only, so they skip
   the v1/v2 routing rules, never fall back to v1 and never trip the v2 circuit breaker. */
const V2 = { baseURL: V2_BASE_URL, _gw: "v2-pinned" };
const base = () => `/v1/${getPracticeId()}/timesheet/corrections`;

export const fetchMyCorrections = () => api.get(`${base()}/mine`, V2);
export const submitCorrection = (id, clockOutTime, note) =>
  api.post(`${base()}/${id}/submit`, { clock_out_time: clockOutTime, note: note || null }, V2);
export const fetchCorrectionQueue = (status = "all") => api.get(base(), { ...V2, params: { status } });
export const decideCorrection = (id, { action, clockOutTime, note } = {}) =>
  api.put(`${base()}/${id}/decision`, { action, clock_out_time: clockOutTime || null, note: note || null }, V2);
export const decideCorrectionsBulk = (ids, action, note) =>
  api.put(`${base()}/decision`, { ids, action, note: note || null }, V2);
export const fetchCorrectionCounts = () => api.get(`${base()}/counts`, V2);
export const fetchCorrectionStatus = (startDate, endDate) =>
  api.get(`${base()}/status`, { ...V2, params: { start_date: startDate, end_date: endDate } });

export const errorMessage = (err, fallback = "Something went wrong. Try again.") => {
  const d = err?.response?.data;
  if (typeof d?.message === "string" && d.message) return d.message;
  if (typeof d?.detail === "string" && d.detail) return d.detail;
  return fallback;
};
